<template>
  <main class="page-main">
    <slot></slot>
  </main>
</template>

<script>
export default { name: 'PageMain' }
</script>
<style lang="postcss">
.page-main {
  @apply w-full;
}
.page.modal {
  @apply mt-0;
}
@screen lg {
  .page--sidebar .page-main {
    @apply px-4 pb-32 ml-auto flex-1 w-8/12;
  }
  .page--sharetools .page-main {
    @apply mr-1/12;
  }
}
</style>